// extracted by mini-css-extract-plugin
export default {"previewImage":"PreviewImage_previewImage__GrhkV"};